<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="reserveTime"
                    label="预约时间"
                >
                    <el-date-picker
                        :picker-options="$utils.CommonConfig.pickerOptions"
                        v-model="queryFormModel.reserveTime"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </el-form-item>
                <el-form-item
                    prop="reserveName"
                    label="预约人"
                >
                    <el-input
                        v-model="queryFormModel.reserveName"
                        placeholder="请输入预约人"
                    />
                </el-form-item>
                <el-form-item
                    prop="reserveNum"
                    label="预约人数"
                >
                    <el-input-number
                        :controls="false"
                        :min="0"
                        v-model.number="queryFormModel.reserveNum"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="reserveTime"
                    label="预约时间"
                    min-width="100"
                >
                    <template #default="scope">
                        {{ scope.row.reserveTime | moment('YYYY-MM-DD') }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="reserveName"
                    label="预约人"
                    min-width="100"
                />
                <el-table-column
                    prop="reserveNum"
                    label="预约人数"
                    min-width="100"
                />
                <el-table-column
                    prop="reserveRemarks"
                    label="预约备注"
                    min-width="100"
                />
                <el-table-column
                    prop="insertTime"
                    label="创建时间"
                    min-width="100"
                >
                    <template #default="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    label="修改时间"
                    min-width="100"
                >
                    <template #default="scope">
                        {{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'VisitReserve',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                reserveTime: [],
                reserveName: '',
                reserveNum: undefined,
            },
            // 表格数据
            tableData: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Mb.VisitReserve.findVisitReserve(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
    },
};
</script>

<style lang="scss">
</style>
